import Image from 'next/image';

import type { ComponentsArticleReviewReview } from 'queries/graphql';

import RatingStars from 'generic/RatingStars';
import MarkdownText from 'generic/MarkdownText';

import { buildImgProps } from 'utils/media';

import styles from './styles.module.sass';

export function Review({
  rating,
  title,
  reviewBody,
  buyerName,
  buyerImage,
}: ComponentsArticleReviewReview) {
  return (
    <div className={styles.gridItem}>
      <div className={styles.content}>
        <div className={styles.top}>
          <RatingStars
            className={styles.stars}
            rating={rating}
            style={{
              starColor: '#ffcd35',
              starEmptyColor: '#b7b7b7',
            }}
          />
          <div className={styles.title}>{title}</div>
          <MarkdownText text={reviewBody} className={styles.reviewBody} />
        </div>

        <div className={styles.buyer}>
          <div className={styles.buyerBio}>
            <div className={styles.buyerName}>{buyerName}</div>
            <div className={styles.verified}>Verified Buyer</div>
          </div>
          <Image
            {...buildImgProps(buyerImage)}
            alt={buyerImage.alt}
            height={60}
            width={60}
            className={styles.buyerImage}
          />
        </div>
      </div>
    </div>
  );
}
